import { render, staticRenderFns } from "./ContractDetail.vue?vue&type=template&id=6688fcb4&scoped=true&lang=pug"
import script from "./ContractDetail.vue?vue&type=script&lang=js"
export * from "./ContractDetail.vue?vue&type=script&lang=js"
import style0 from "./ContractDetail.vue?vue&type=style&index=0&id=6688fcb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6688fcb4",
  null
  
)

export default component.exports